export default __webpack_public_path__ + "static/media/button-play.c44e981c.svg";